import {
  IsEmail,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

import { TeamLanguage } from '@coworkrz/teams/types';

export class CreateTeamDto {
  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  businessRegistrationNumber?: string;

  @IsString()
  @IsOptional()
  niu?: string;

  @IsString()
  @IsNotEmpty()
  phone: string;

  @IsString()
  @IsOptional()
  website?: string;

  @IsString()
  @IsNotEmpty()
  city: string;

  @IsString()
  @IsOptional()
  postalBox?: string;

  @IsEnum(TeamLanguage)
  @IsOptional()
  lang?: TeamLanguage;
}

export class UpdateTeamDto {
  @IsEmail()
  @IsOptional()
  email: string;

  @IsNotEmpty()
  @IsString()
  @IsOptional()
  name?: string;

  @IsString()
  @IsOptional()
  businessRegistrationNumber?: string;

  @IsString()
  @IsOptional()
  niu?: string;

  @IsNotEmpty()
  @IsString()
  @IsOptional()
  phone?: string;

  @IsString()
  @IsOptional()
  website?: string;

  @IsNotEmpty()
  @IsString()
  @IsOptional()
  city?: string;

  @IsString()
  @IsOptional()
  postalBox?: string;

  @IsEnum(TeamLanguage)
  @IsOptional()
  lang?: TeamLanguage;
}

export class TeamMemberDto {
  @IsUUID()
  memberId: string;
}
